import { render, staticRenderFns } from "./DialogCreateUser.vue?vue&type=template&id=4af53cf0&scoped=true"
import script from "./DialogCreateUser.vue?vue&type=script&lang=ts"
export * from "./DialogCreateUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af53cf0",
  null
  
)

export default component.exports